import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { MyContext } from "./helpers/contextHelper";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/page/login"));
// const Register = React.lazy(() => import('./views/pages/register/Register'));
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {
  state = {
    user: {
      role: "",
      _id: "",
      email: "",
      password: "",
      accessToken: "",
      __v: 0,
      expireTime: "",
    },
  };

  setUser = (user) => {
    this.setState({ user: user });
  };

  render() {
    return (
      <MyContext.Provider
        value={{ user: this.state.user, setUser: this.setUser }}
      >
        <HashRouter>
          <React.Suspense fallback={loading}>
            <ReactNotifications />
            <Switch>
              {/* <Route
                path="/Login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
             <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} /> */}
              <Route
                path="/"
                name="Dashboard"
                render={(props) => <TheLayout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </HashRouter>
      </MyContext.Provider>
    );
  }
}

export default App;
